// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Input from "react-toolbox/lib/input"
import DatePicker from "../../../components/DatePicker"
import * as strings from "../../../strings"

export default class CreateInvoice extends Component {
  props: {
    newInvoice: any,
    onChange: any,
    areInputFieldsValid: any,
  }

  render () {

    return (
      <div clasName={style.mainContainer}>
        <div className={style.blueBar}>
        </div>
        <div className={style.firstDivisor}>
          <div className={style.firstLine}>
            <span><hr className={style.divider}/></span>
          </div>
          <div className={style.secondLine}>
            <span className={style.spanText}>{strings.invoices.createInvoice}</span>
          </div>
          <div className={style.thirdLine}>
            <span><hr className={style.divider}/></span>
          </div>
        </div>
        <div className={style.createContainer}>
          <div className={style.createContainerColumn}>
            <Input
              className={style.inputFix}
              error={this.props.areInputFieldsValid[ 0 ]}
              value={this.props.newInvoice.documentNumber}
              onChange={value => this.props.onChange( {
                documentNumber: value,
              } )}
              label="Número da factura"
              type="text" />
            <Input
              className={style.inputFix}
              error={this.props.areInputFieldsValid[ 1 ]}
              value={this.props.newInvoice.value}
              onChange={value => this.props.onChange( {
                value: parseFloat( value ),
              } )}
              label={strings.generalStrings.invoiceValue}
              step="0.01"
              min="0.00"
              type="number" />
          </div>
          <div className={[ style.createContainerColumn, style.datePickerCss ].join( " " )}>
            <DatePicker
              error={this.props.areInputFieldsValid[ 2 ]}
              label="Data de Emissão"
              onChange={value => this.props.onChange( {
                date: new Date( value ),
              } )}
              value={ this.props.newInvoice.date }
            />
            <DatePicker
              error={this.props.areInputFieldsValid[ 3 ]}
              label="Data de Vencimento"
              onChange={value => this.props.onChange( {
                expiryDate: new Date( value ),
              } )}
              value={ this.props.newInvoice.expiryDate }
            />
          </div>
          <div className={style.createContainerColumn}>
            <Input
              className={style.inputFix}
              error={this.props.areInputFieldsValid[ 4 ]}
              value={this.props.newInvoice.contractNumber}
              onChange={value => this.props.onChange( {
                contractNumber: value,
              } )}
              label={strings.paymentAgreements.contractNumber}
              type="text" />
            <Input
              className={style.inputFix}
              error={this.props.areInputFieldsValid[ 5 ]}
              value={this.props.newInvoice.address}
              onChange={address => this.props.onChange( { address } )}
              label="Local de consumo"
              type="text" />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CreatePaymentAgreementComponents/CreateInvoice/index.jsx